import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/studentSidebar";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useHandleAssignAndQuiz } from "../../../core/hooks/useHandleAssignAndQuiz";
import CourseCard from "../common/courseCard";
import { Pagination } from "../../../core/common/ults/pagination";
import Skeleton from "react-loading-skeleton";
import LiveClassDashboard from "../common/liveClassDashboard";

const StudentDashboard = () => {
  const { t } = useTranslation();
  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading } = useHandleCourses(
    moodleUser?.id
  );
  const { isQuizzesLoading } = useHandleAssignAndQuiz();

  const itemsPerPage = 3; // Số lượng courses hiển thị trên mỗi trang
  const [currentPage, setCurrentPage] = useState(1);

  // Tính toán dữ liệu hiển thị
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentCourses = enrolledCourses?.length > 0 ? enrolledCourses?.slice(
    startIndex,
    startIndex + itemsPerPage
  ) : [];

  // Fake percent cho mỗi khoá học
  const fakePercents = [20, 50, 80, 35, 60, 90, 10, 75, 40, 55];

  return (
    <div className="content">
      <div className="container">
        {/* profile box */}
        <ProfileCard />
        {/* profile box */}
        <div className="row">
          {/* sidebar */}
          <StudentSidebar />
          {/* sidebar */}
          <div className="col-lg-9">
            <Breadcrumb title={t("studentDashboard.title")} />
            <div className="card bg-light quiz-ans-card">
              <ImageWithBasePath
                src="./assets/img/shapes/withdraw-bg1.svg"
                className="quiz-ans-bg1"
                alt="img"
              />
              <ImageWithBasePath
                src="./assets/img/shapes/withdraw-bg2.svg"
                className="quiz-ans-bg2"
                alt="img"
              />
              {/* <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-8">
                      <div>
                        <h6 className="mb-1">
                          {t("studentDashboard.quiz.title")}: Build Responsive
                          Real World
                        </h6>
                        <p>{t("studentDashboard.quiz.answered")}: 15/22</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-end">
                        <Link
                          to={all_routes.studentQuiz}
                          className="btn btn-primary rounded-pill"
                        >
                          {t("studentDashboard.quiz.continueQuiz")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div> */}
            </div>
            {/* <div className="row">
                <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                          <ImageWithBasePath
                            src="assets/img/icon/graduation.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <span className="d-block">
                            {t("studentDashboard.stats.enrolledCourses")}
                          </span>
                          <h4 className="fs-24 mt-1">
                            {enrolledCourses?.length}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                          <ImageWithBasePath
                            src="assets/img/icon/book.svg"
                            alt=""
                          />
                        </span>
                        <div>
                          <span className="d-block">
                            {t("studentDashboard.stats.activeCourses")}
                          </span>
                          <h4 className="fs-24 mt-1">
                            {enrolledCourses?.length}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
            {/* <div className="col-md-6 col-xl-4">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                    <ImageWithBasePath src="assets/img/icon/bookmark.svg" alt="" />
                  </span>
                  <div>
                    <span className="d-block">Completed Courses</span>
                    <h4 className="fs-24 mt-1">10</h4>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
            {/* </div> */}

            <h5 className="mb-3 fs-18">
              {t("studentDashboard.recentCourses.title")}
            </h5>
            <div className="row">
              {isEnrolledCoursesLoading ? (
                <Skeleton height={200} className="mb-3" />
              ) : (
                enrolledCourses?.length > 0 && (
                  <>
                    {currentCourses?.map((course: any, index: any) => (
                      <div key={index} className="col-xl-4 col-md-6">
                        <CourseCard
                          course={course}
                          index={index}
                          progressPercent={
                            fakePercents[startIndex + index] || 0
                          }
                        />
                      </div>
                    ))}
                  </>
                )
              )}
              <Pagination
                totalItems={enrolledCourses?.length}
                itemsPerPage={itemsPerPage}
                onPageChange={(page: number) => setCurrentPage(page)}
              />
            </div>
            <div className="mb-4">
              <LiveClassDashboard maxItems={3} />
            </div>
            <div>
              <div className="row">
                {/* Lịch sử giao dịch */}
                {/* <div className="col-xl-7">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="mb-3 border-bottom pb-3 fs-18">
                          Recent Invoices
                        </h5>
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                          <div>
                            <h6 className="mb-1">
                              Build Responsive Real World Websites..
                            </h6>
                            <div className="d-flex align-items-center">
                              <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                #INV001
                              </span>
                              <p className="small">
                                Amount :{" "}
                                <span className="heading-color fw-semibold">
                                  $200
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge fw-normal bg-success d-inline-flex align-items-center me-1">
                              <i className="fa-solid fa-circle fs-5 me-1" />
                              Paid
                            </span>
                            <Link to="#" className="action-icon">
                              <i className="isax isax-document-download" />
                            </Link>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                          <div>
                            <h6 className="mb-1">Wordpress for Beginners</h6>
                            <div className="d-flex align-items-center">
                              <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                #INV002
                              </span>
                              <p className="small">
                                Amount :{" "}
                                <span className="heading-color fw-semibold">
                                  $310
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge fw-normal bg-success d-inline-flex align-items-center me-1">
                              <i className="fa-solid fa-circle fs-5 me-1" />
                              Paid
                            </span>
                            <Link to="#" className="action-icon">
                              <i className="isax isax-document-download" />
                            </Link>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                          <div>
                            <h6 className="mb-1">
                              Information About UI/UX Design Degree
                            </h6>
                            <div className="d-flex align-items-center">
                              <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                #INV003
                              </span>
                              <p className="small">
                                Amount :{" "}
                                <span className="heading-color fw-semibold">
                                  $270
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge fw-normal bg-success d-inline-flex align-items-center me-1">
                              <i className="fa-solid fa-circle fs-5 me-1" />
                              Paid
                            </span>
                            <Link to="#" className="action-icon">
                              <i className="isax isax-document-download" />
                            </Link>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                          <div>
                            <h6 className="mb-1">Sketch from A to Z (2024)</h6>
                            <div className="d-flex align-items-center">
                              <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                #INV004
                              </span>
                              <p className="small">
                                Amount :{" "}
                                <span className="heading-color fw-semibold">
                                  $180
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge fw-normal bg-success d-inline-flex align-items-center me-1">
                              <i className="fa-solid fa-circle fs-5 me-1" />
                              Paid
                            </span>
                            <Link to="#" className="action-icon">
                              <i className="isax isax-document-download" />
                            </Link>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                          <div>
                            <h6 className="mb-1">Become an app designer</h6>
                            <div className="d-flex align-items-center">
                              <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                #INV005
                              </span>
                              <p className="small">
                                Amount :{" "}
                                <span className="heading-color fw-semibold">
                                  $220
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="badge fw-normal bg-success d-inline-flex align-items-center me-1">
                              <i className="fa-solid fa-circle fs-5 me-1" />
                              Paid
                            </span>
                            <Link to="#" className="action-icon">
                              <i className="isax isax-document-download" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                {/* Lịch sử giao dịch */}
                {/* <div className="col-xl-12">
                    <div className="card mb-0">
                      <div className="card-body">
                        <h5 className="mb-3 fs-18 border-bottom pb-3">
                          {t("studentDashboard.latestQuizzes.title")}
                        </h5>
                        {isQuizzesLoading ? (
                          <Skeleton height={100} className="mb-3" />
                        ) : (
                          <>
                            {quizzes?.data?.map((quiz: any, index: any) => {
                              if (quiz.status === quizStatus.submited) {
                                const quizGradeItem = quizGrade?.find((item: any) => item?.quiz_id === quiz?.id);
                                const roundedQuizGrade: any = parseFloat(quizGradeItem?.diem_he_10).toFixed(2);
                                return (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3"
                                  >
                                    <div>
                                      <h6 className="mb-1">{quiz?.name}</h6>
                                      <div className="d-flex align-items-center">
                                        <p>
                                          {t('studentDashboard.latestQuizzes.grade')}: {roundedQuizGrade}/{quiz?.grade}
                                        </p>
                                      </div>
                                    </div>
                                    <CircleProgress
                                      value={(roundedQuizGrade / quiz?.grade) * 100}
                                    />
                                  </div>
                                );
                              }
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;
